import React from "react";
import Moment from "moment";
import { CalenderIcon, ClockIcon } from "../../../icons";
import formatDateTime from "../../Common/formatDateTime";
import { POST_STATUS } from "../../../common/constants";
const PostPreviewStatic = props => {
  const { postTime, readTime, category, status } = props;
  return (
    <React.Fragment>
      <div className="events-page-post-static">
        {category ? (
          <div className="events-page-post-static-item">
            <div className="events-page-post-static-item-text events-page-post-static-item-cat">
              {category?.name}
            </div>
          </div>
        ) : null}
        {postTime ? (
          <div className="events-page-post-static-item">
            <div className="events-page-post-static-item-text">
              <CalenderIcon />
              {postTime
                ? status === POST_STATUS?.[2]?.value ||
                  status === POST_STATUS?.[3]?.value
                  ? Moment(postTime).format("MMM DD YYYY hh:mm A")
                  : formatDateTime(postTime)
                : "-"}
            </div>
          </div>
        ) : null}
        <div className="events-page-post-static-item">
          <div className="events-page-post-static-item-text">
            <ClockIcon /> {readTime}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PostPreviewStatic;
